import * as React from 'react'
import { BaseComponentProps } from '../Common/extractClassNamesFromProps'
import { extractClassNamesFromProps } from '../Common/extractClassNamesFromProps'
import * as st from './Radio.module.scss'
import * as cn from 'classnames'

interface RadioProps extends BaseComponentProps {
  id: string
  name: string
  label: string
  checked?: boolean
  description?: string
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

interface RadioState {
  checked: boolean
}

export class Radio extends React.Component<RadioProps, RadioState> {
  static displayName = 'Radio';

  constructor(props: RadioProps) {
    super(props)
    this.state = {
      checked: props.checked || false
    }
  }

  onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      checked: event && !this.state.checked
    })
  }

  static getDerivedStateFromProps = (props: RadioProps) => {
    return {
      checked: props.checked || false
    }
  }

  render() {
    const { props, state } = this
    const className = extractClassNamesFromProps(props, st.radio)
    return (
      <div className={className}>
        <input className={st.radioInput} type="radio" onChange={props.onChange || this.onChange} defaultChecked={state.checked} id={props.id} name={props.name} />
        <label htmlFor={props.id}>
          <span>{props.label}</span>
          {props.description && <span>{props.description}</span>}
        </label>
        <div className={cn(st.check, {
          [st.hasDescription]: props.description
        })} />
      </div>
    )
  }
}

interface RadioContainerProps extends BaseComponentProps {
  onChange: (id: string) => void
}

interface RadioContainerState {
  selected: string|null
}

export class RadioContainer extends React.Component<RadioContainerProps, RadioContainerState> {
  constructor(props: RadioContainerProps & { children?: React.ReactNode }) {
    super(props)
    const radio = (React.Children.toArray(props.children) as unknown as Array<Radio>).find(child => child.props.checked)
    this.state = {
      selected: radio ? radio.props.id : null
    }
  }

  onChange = (id: string) => {
    this.setState({
      selected: id
    })
    this.props.onChange(id)
  }

  render() {
    const { props } = this

    return (<>
        {React.Children.map(props.children, child => (
          (typeof child === 'number' || typeof child === 'string' || (child.type && (child.type as React.ComponentClass).displayName !== 'Radio')) ? null : React.cloneElement(child, {
            onChange: this.onChange.bind(this, child.props.id),
            checked: this.state.selected === child.props.id
          })
        ))}
      </>
    )
  }
}
